import { useState } from "react";
import { Link } from "react-router-dom";
import { Printer } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Reveal, Eyebrow } from "./Reveal";

export const PrintCTA = ({ cats }) => {
  const [cat, setCat] = useState("all");
  const to = cat === "all" ? "/print" : `/print?cat=${cat}`;
  return (
    <Reveal className="relative overflow-hidden border border-[#D4AF37]/25 bg-[#13141C] p-8 sm:p-14 lg:p-20 grid lg:grid-cols-2 gap-12 items-center">
      <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="relative">
        <Eyebrow>Printable edition</Eyebrow>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F3EF] leading-[1]">
          The Atlas, <em className="text-[#E5C158]">on paper.</em>
        </h2>
        <p className="mt-6 text-[#A09E97] max-w-md">
          A typeset A4 edition with cover, contents and a section for every collection. Print the whole catalogue or a single category, or save it as PDF.
        </p>
      </div>
      <div className="relative flex flex-col sm:flex-row gap-4 lg:justify-end">
        <Select value={cat} onValueChange={setCat}>
          <SelectTrigger data-testid="print-cta-category-select" className="h-14 sm:w-64 rounded-full bg-[#0D0D11] border-[#D4AF37]/30 text-[#F5F3EF] px-6">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-[#13141C] border-[#D4AF37]/30 text-[#F5F3EF]">
            <SelectItem value="all">Full catalogue</SelectItem>
            {cats.map((c) => <SelectItem key={c.id} value={c.slug}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Link to={to} data-testid="print-cta-open-btn"
          className="h-14 inline-flex items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-8 text-[#0D0D11] font-medium hover:bg-[#E5C158] transition-colors duration-300">
          <Printer className="w-4 h-4" /> Open A4 edition
        </Link>
      </div>
    </Reveal>
  );
};
